import React from 'react';
import './FetchError.css';

/**
 * Accessible error state with retry for failed API loads.
 */
export default function FetchError({ message, onRetry, details }) {
  return (
    <div className="fetch-error" role="alert">
      <p className="fetch-error__message">{message}</p>
      {details ? <p className="fetch-error__details">{details}</p> : null}
      {onRetry ? (
        <button type="button" className="fetch-error__retry" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </div>
  );
}
